import styled from "styled-components"
import { Link } from "react-router-dom"
import { tablet, mobile, smallScreen } from "../../Responsive"

export const Container = styled.div`
   border: 1.5px solid var(--secondary);
   border-radius: 10px;
   margin: 20px 0px;
   padding: 20px;

   ${tablet({ margin: "10px 0px" })}
   @media screen and (max-width: ${smallScreen}) {
      font-size: var(--fontXS);
   }
`

export const Wrapper = styled.div`
   display: flex;
   justify-content: space-between;
   margin-bottom: 20px;

   ${mobile({ flexDirection: "column" })}
`

export const Title = styled.h1`
   flex: 1;
   font-weight: 200;

   @media screen and (max-width: ${smallScreen}) {
      font-size: var(--fontL);
   }
`
export const ButtonWrapper = styled.div`
   flex: 1;
   margin-top: -20px;

   ${mobile({ marginTop: "0px" })}
`

export const StyledLink = styled(Link)`
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   text-decoration: none;
   cursor: pointer;
   color: var(--secondary);
   transition: all 0.5s ease;

   &:hover {
      color: var(--primary);
      transform: scale(1.1);
   }
`
